import React from 'react';
import { generateWorkflowConfig } from '@carrier-ecat/ngecat-commonworkflowui';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import { RULES, RULESETS } from './constants/rules';
import { Select, InputRange, RadioGroup, Typography } from '@carrier-ecat/ngecat-tsreactcomponents';
const NAAppliedRTUCWConfig = generateWorkflowConfig({
    platformConfiguration: {
        guid: 'a013f71b-d2f2-4470-a1b3-8eb4423ba4fb',
        name: 'Applied Rooftop NAO CW',
        urlPath: '/ARTUNao',
        region: 'NA'
    },
    global: {
        assetStoragePath: '',
        permissions: [],
        currentVersion: '1.0.0',
        currency: 'USD',
    },
    tags: {
        partNumber: 'PN_sModel',
        tagModel: 'BU_sModel',
        tagSize: 'BU_sUnitSize',
        tagQty: 'Tag_nQty',
    },
    rules: {
        productLine: 'Applied Rooftops NAO',
        rulesets: RULESETS,
        rules: RULES,
        rulesOutputVersion: 5,
        selectionRuleset: 'SEL_RTU',
        validityPropName: 'Tag_bConfigValid',
        rulesetPropName: 'Tag_sConfigRuleset',
        candidateRulesDefinition: [{ propertyName: 'BU_sModel', displayName: 'Model' }, { propertyName: 'BU_sUnitSize', displayName: 'Unit Size' }],
        PartNumber: 'PN_sModel',
    },
    strategies: {
        defaulting: {
            getInitialStateAtStepChange: false,
        },
    },
    capabilities: {
        releaseNote: false,
        debug: true,
        searchableConfiguration: false,
        showPrice: true,
        cart: true,
    },
    steps: [
        {
            stepIndex: 0,
            type: 'default',
            name: 'Describe requirements',
            tags: [],
            sections: [
                {
                    label: 'Requirements',
                    id: '1-1',
                    icon: () => React.createElement(AcUnitIcon, null),
                    components: [
                        {
                            cells: [
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sHeatType',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Heat Type',
                                    },
                                },
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sApplicationType',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Application Type',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sHeatCapacity',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Heat Capacity',
                                    },
                                },
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sSupplyReturn',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Supply/Return',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    label: 'Model',
                    id: '1-1',
                    icon: () => React.createElement(AcUnitIcon, null),
                    components: [
                        {
                            cells: [
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sVoltage',
                                    },
                                    size: 4,
                                    props: {
                                        label: 'Voltage',
                                    },
                                },
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sModel',
                                    },
                                    size: 4,
                                    props: {
                                        label: 'Model',
                                    },
                                },
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'BU_sUnitSize',
                                    },
                                    size: 4,
                                    props: {
                                        label: 'Unit Size',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            stepIndex: 1,
            type: 'default',
            name: 'Detail conditions',
            tags: [],
            sections: [
                {
                    label: 'Unit',
                    id: '2-1',
                    icon: () => React.createElement(AcUnitIcon, null),
                    components: [
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fAltitudeFt',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Altitude',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fSupplyAirFlow',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Total Cooling Airflow',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fExternalStatic',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'External Static Pressure',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fSupplyHeatingAirFlow',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Total Heating Airflow',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    label: 'Coil Conditions',
                    id: '2-2',
                    icon: () => React.createElement(AcUnitIcon, null),
                    components: [
                        {
                            cells: [
                                {
                                    component: React.createElement(RadioGroup, { name: "DC_sCoilConditionMethod", row: true }),
                                    rule: {
                                        name: 'DC_sCoilConditionMethod',
                                    },
                                    size: 6,
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(Typography, { align: "left", variant: "subtitle1", color: "primary" }),
                                    size: 6,
                                    props: {
                                        label: 'Outdoor Air',
                                        visible: true,
                                    },
                                },
                                {
                                    component: React.createElement(Typography, { align: "left", variant: "subtitle1", color: "primary" }),
                                    size: 6,
                                    props: {
                                        label: 'Mixed Air (Entering Indoor Coil)',
                                        visible: true,
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoorAir_DryBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Dry Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoorAir_DryBulbHeating',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Dry Bulb Heating',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fMixedAir_EIC_DryBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Evap. Ent. Air Dry Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fMixedAir_EIC_DryBulbHeating',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Ent. Air Dry Bulb Heating',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoorAirCFM',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Outdoor Airflow',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoorAir_WetBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Wet Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fMixedAir_EIC_DryBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Evap. Ent. Air Dry Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fMixedAir_EIC_WetBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Evap. Ent. Air Wet Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoorAir_WetBulbHeating',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Wet Bulb Heating',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(Typography, { align: "left", variant: "subtitle1", color: "primary" }),
                                    rule: {
                                        name: 'DC_fReturnAir_DryBulbCooling',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Return Air',
                                    },
                                },
                                {
                                    component: React.createElement(Typography, { align: "left", variant: "subtitle1", color: "primary" }),
                                    rule: {
                                        name: 'DC_fOutdoor_EOC_DryBulbCooling',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Outdoor Air (Entering Outdoor Coil)',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fReturnAir_DryBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Dry Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fReturnAir_DryBulbHeating',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Dry Bulb Heating',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fOutdoor_EOC_DryBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Cond. Ent. Air Dry Bulb Cooling',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fReturnAir_WetBulbCooling',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Wet Bulb Cooling',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fReturnAir_WetBulbHeating',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Wet Bulb Heating',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    label: 'Hot Water Heat',
                    id: '2-3',
                    icon: () => React.createElement(AcUnitIcon, null),
                    manageVisibility: (properties) => {
                        return properties.BU_sHeatType?.value === 'HOTWATERCOIL';
                    },
                    components: [
                        {
                            cells: [
                                {
                                    component: React.createElement(Select, null),
                                    rule: {
                                        name: 'DC_sHotwaterFluid',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Fluid Type',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fHotWaterEnteringFluidTemp',
                                    },
                                    size: 6,
                                    props: {
                                        label: 'Entering Fluid Temp.',
                                    },
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    rule: { name: 'DC_sHotWaterFlowRate' },
                                    component: React.createElement(RadioGroup, { name: "DC_sHotWaterFlowRate", row: true }),
                                    size: 12,
                                },
                            ],
                        },
                        {
                            cells: [
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fHotWaterFlowRate',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Flow Rate',
                                    },
                                },
                                {
                                    component: React.createElement(InputRange, null),
                                    rule: {
                                        name: 'DC_fHotWaterTempDrop',
                                    },
                                    size: 3,
                                    props: {
                                        label: 'Temp Drop',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            stepIndex: 2,
            type: 'candidate',
            name: 'Candidate selection',
            tags: [],
            mapping: {
                path: {
                    datasource: 'applied-rooftops-nao/CW/mapping/DataSource_Mapping.json',
                    metadata: 'applied-rooftops-nao/CW/mapping/MetaData_Mapping.json',
                },
                selectionCalcProps: {
                    gridProperties: {
                        singleSelectGrid: true,
                    },
                    enableActionButtons: false,
                    additionalAssigmentsToAppend: {
                        Selection: {
                            Calc_sCalculationEngine: {
                                Value: 'LegacyRTU30',
                            },
                            Calc_sMappingFileName: {
                                Value: 'Mapping_AppliedRooftop_NAO.xml',
                            },
                            Calc_bSelection: {
                                Value: 'TRUE',
                            },
                            Calc_XMLFormat: {
                                Value: '4',
                            },
                        },
                    },
                    propForGridMessageOnRowSelection: [],
                    propNameForModelNumber: 'BU_sModel',
                },
            },
        },
        {
            stepIndex: 3,
            type: 'configuration',
            name: 'Configuration',
            tags: [],
            sections: [
                {
                    label: 'Options',
                    id: 'options',
                    allCategories: true,
                    icon: () => React.createElement(AcUnitIcon, null),
                    rulesCategoryName: 'Opt_sCategory',
                    tags: ['UI_CONFIG_UNIT_OPT'],
                },
                {
                    label: 'Accessories',
                    id: 'accessories',
                    icon: () => React.createElement(AcUnitIcon, null),
                    rulesCategoryName: 'Acc_sCategory',
                    tags: ['UI_CONFIG_UNIT_ACC'],
                    isSearchable: false,
                },
                {
                    label: 'Warranties',
                    id: 'warranties',
                    icon: () => React.createElement(AcUnitIcon, null),
                    rulesCategoryName: 'War_sCategory',
                    tags: ['UI_CONFIG_UNIT_WAR'],
                },
            ],
        },
        {
            stepIndex: 4,
            type: 'default',
            name: 'Reports',
            tags: [],
            sections: [],
        },
    ],
});
export default NAAppliedRTUCWConfig;
